import { Onboarding } from '@web/onboarding/components/Onboarding';

export default {
  ReactComponent: Onboarding,
  bindings: {
    user: '<',
    locations: '<',
    saveClientFlags: '&',
    updateCurrentOrg: '&',
    updateCurrentUser: '&',
    setFirstRun: '&',
    loadPersonaCollection: '&',
    addPersonaCollectionGroup: '&',
    addPersonaCollectionUser: '&',
    positions: '<',
    onClose: '&',
    toastIntegration: '<',
  },
};
